import Profissional from "../models/Profissional";

export default class Checklist {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.detalhe = "Equipamento Eletromecânico";
    this.local = "Base da Netech / Mossoró-RN";
    this.periodo = "A cada 6 meses";
    this.itens = this.getDefaultItens();
    this.resultado = "APROVADO";
    this.observacao =
      "Os operadores desse equipamento devem ser devidamente qualificados e legalmente habilitados, os trabalhadores devem portar crachá de identificação e qualificação, do qual conste a data de seu último exame médico ocupacional e treinamento realizado.";
    this.inspetor = new Profissional();
  }

  getDefaultItens() {
    let list = [];
    for (let index = 1; index < 14; index++) {
      list.push({
        item: "" + index,
        conjunto: "- - -",
        descricao: "- - -",
        laudo: true,
      });
    }
    return list;
  }
}
